import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  changePasswordButton: {
    textTransform: 'none',
    fontWeight: 400,
  },
}))
